export default __webpack_public_path__ + "static/flow-74f512be5910c31281f46f138488be57.mp4";